var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8051 10.7967C1.92402 11.7545 2.69779 12.5111 3.65772 12.6115C4.98601 12.7503 6.36268 12.8969 7.77344 12.8969C9.1842 12.8969 10.5609 12.7503 11.8892 12.6115C12.8491 12.5111 13.6229 11.7545 13.7418 10.7967C13.8837 9.65314 14.0234 8.47052 14.0234 7.25999C14.0234 6.04945 13.8837 4.86684 13.7418 3.7233C13.6229 2.7655 12.8491 2.00886 11.8892 1.90851C10.5609 1.76966 9.1842 1.62305 7.77344 1.62305C6.36268 1.62305 4.98601 1.76966 3.65772 1.90851C2.69779 2.00886 1.92402 2.7655 1.8051 3.7233C1.66313 4.86684 1.52344 6.04945 1.52344 7.25999C1.52344 8.47052 1.66313 9.65313 1.8051 10.7967Z",
    fill: "#84C70D",
    fillOpacity: 0.1,
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83203 3.46484L6.53415 7.17231C7.26039 7.74493 8.28453 7.74493 9.01078 7.17231L13.7129 3.46484",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail-outline.e2ad332a3154275cef3b0c67ce64d51f.svg";
export { ForwardRef as ReactComponent };